import React, { useState, useEffect, useCallback } from 'react';
import { Helmet } from 'react-helmet';

const TurboHead = () => {
    const [metaData, setMetaData] = useState({
        urlSlug: '',
        titleTag: '',
        metaDescription: '',
        markupName: '',
        jsonLdMarkup: '',
        ogTitle: '',
        ogDescription: '',
        ogImage: '',
    });
    const [jsonData, setJsonData] = useState(null);

    // Use useCallback for the fetch function to prevent unnecessary re-renders
    const fetchSeoData = useCallback(async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_PROD_URL}/seo-settings/turboseo001`);
            if (response.ok) {
                const result = await response.json();
                const data = result.data;
                setMetaData({
                    urlSlug: data.urlSlug || '',
                    titleTag: data.titleTag || '',
                    metaDescription: data.metaDescription || '',
                    markupName: data.markupName || '',
                    jsonLdMarkup: data.jsonLdMarkup || '',
                    ogTitle: data.ogTitle || '',
                    ogDescription: data.ogDescription || '',
                    ogImage: data.ogImage || '',
                });
                const jsonObjects = JSON.parse(`[${data.jsonLdMarkup}]`);
                setJsonData(jsonObjects);
            }
        } catch (error) {
            // Error handling
        }
    }, []);

    useEffect(() => {
        fetchSeoData();
    }, [fetchSeoData]);
    
    return (
        <>
            <Helmet>
                {/* Dynamically setting title, meta, and Open Graph tags */}
                <title>{metaData.titleTag}</title>
                <meta name="description" content={metaData.metaDescription} />
                <link rel="canonical" href={metaData.urlSlug} />
                <meta property="og:title" content={metaData.ogTitle} />
                <meta property="og:site_name" content="Colorbot" />
                <meta property="og:url" content={metaData.urlSlug} />
                <meta property="og:description" content={metaData.ogDescription} />
                <meta property="og:type" content="website" />
              
                {/* Dynamically include JSON-LD markup */}
                {jsonData && jsonData.map((data, index) => (
                    <script type="application/ld+json" key={index}>
                        {JSON.stringify(data)}
                    </script>   
                ))}
            </Helmet>
        </>
    );
};

export default React.memo(TurboHead);
